import { PopoverClose } from '@radix-ui/react-popover';
import { Button, cn, TimeType } from '@sib/ui';
import { ChevronDown } from '@sib/ui/icons';
import { ScrollSelect } from './ScrollSelect';
import { hoursOptions, minutesOptions } from './TimePickerSelect.utils';

export interface TimePickerSelectProps {
  selected: Date | null;
  setOpenedState: (state: boolean) => void;
  handleTimeChange: (type: TimeType, value: string) => void;
  topLabel?: string;
  confirmLabel: string;
  onBackToDateSelection?: () => void;
}

export const TimePickerSelect = ({
  selected,
  setOpenedState,
  handleTimeChange,
  topLabel,
  confirmLabel,
  onBackToDateSelection,
}: TimePickerSelectProps) => (
  <div className="xs:w-[350px] flex w-[calc(100vw-30px)] flex-col gap-3 px-3 pb-4">
    <div
      className={cn(
        'text-primary border-border flex flex-row items-center gap-2 py-4',
        !!topLabel && 'border-b'
      )}
    >
      {onBackToDateSelection && (
        <Button size="custom" variant="ghost" onClick={onBackToDateSelection}>
          <ChevronDown className="size-3.5 rotate-90" />
        </Button>
      )}

      {topLabel && <span className="text-sm leading-4">{topLabel}</span>}
    </div>
    <div className="flex w-full flex-row justify-center divide-x">
      <div className="flex w-full flex-row items-center">
        <ScrollSelect
          options={hoursOptions}
          value={selected ? selected?.getHours() : new Date().getHours()}
          onChange={value => handleTimeChange(TimeType.Hour, value)}
        />
        <span className="text-xl">:</span>

        <ScrollSelect
          options={minutesOptions}
          value={selected ? selected?.getMinutes() : new Date().getMinutes()}
          onChange={value => handleTimeChange(TimeType.Minute, value)}
        />
      </div>
    </div>
    <PopoverClose onClick={() => setOpenedState(false)} asChild>
      <Button variant="outline">{confirmLabel}</Button>
    </PopoverClose>
  </div>
);
